import axios from "axios";
import API from "../helpers/api";
let searchData={
    CrewId: '',
    PageNumber: 1,
    PageSize: 25
}
export const getKeywordList = (item) => {
    let url = `${API.SearchCrew}?Name=${item.CrewId}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getKeywordListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getKeywordListFailure",
                    error: "ERROR"
                })
            })
    }
}
// let items ={data: [
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     },
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     },
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     },
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     },
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     },
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     },
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     },
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     },
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     },
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     },
//     {
//         "crewID": "ABC121",
//         "name": "Test Crew Member",
//         "designation": "Staff",
//         "shipName": "Ship 1",
//         "photo": "new.img"

//     }
// ],
// pagination:{
//     "currentPage": 1,
//     "hasNext": false,
//     "hasPrevious": false,
//     "pageSize": 50,
//     "totalPages": 1,
//     "totalcount": 1
// }
// // }
// return dispatch => {
//     dispatch({
//         type: "getKeywordListSuccess",
//         data: items,
//     })
// }
// }
export const postKeywordList = (data) => {
    let url = `${API.postKeyword}`;
    return dispatch => {
        axios.post(url,data)
            .then((response) => {
                dispatch(getKeywordList(searchData));
                dispatch({
                    type: "postKeywordSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postKeywordFailure",
                    error: "ERROR"
                })
            })
    }
}
export const putKeywordList = (data) => {
    let url = `${API.postKeyword}`;
    return dispatch => {
        axios.put(url,data)
            .then((response) => {
                dispatch(getKeywordList(searchData));
                dispatch({
                    type: "updateKeywordSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "updateKeywordFailure",
                    error: "ERROR"
                })
            })
    }
}
export const deleteKeywordList = (data) => {
    let url = `${API.postKeyword}`;
    return dispatch => {
        axios.put(url,data)
            .then((response) => {
                dispatch(getKeywordList(searchData));
                dispatch({
                    type: "deleteKeywordSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "deleteKeywordFailure",
                    error: "ERROR"
                })
            })
    }
}

